import React, { Component } from 'react';
import PhotoThumb from '../PhotoThumb';

export default class NameToFaceActivity extends Component {
  render() {
    const { activity } = this.props;
    return (
      <div className="activity__nametoface">
        <div className="activity__paragraph">
          {activity.data.title}. {activity.data.desc}
        </div>
        <PhotoThumb photoUrl={activity.photo_url} />
      </div>
    );
  }
}
